export const GLASS_THEMES = [
  "A mountain stream winding through pine trees",
  "A golden sunrise over a quiet valley",
  "A bird soaring through the open sky",
  "A moonlit lake reflecting the stars",
  "A waterfall cascading into a turquoise pool",
  "A lighthouse guiding boats through the mist",
  "A sunflower turning toward the light",
  "A butterfly resting on a wildflower",
  "A rainbow arching over rolling hills",
  "A snowy mountain beneath a pink sky",
  "A forest path glowing with autumn leaves",
  "A hummingbird visiting a bright blossom",
  "A sailboat crossing a sapphire sea",
  "A fox curled beneath a woodland tree",
  "A garden filled with jewel-colored flowers",
  "A campfire beneath a sky full of stars",
  "A river flowing through a desert canyon",
  "A cherry tree covered in spring blossoms",
  "A sea turtle drifting above a coral reef",
  "A crescent moon above a sleeping village",
  "A dragonfly hovering over water lilies",
  "A warm sunset across the ocean",
  "An owl watching from an old oak tree",
  "A field of poppies dancing in the breeze",
  "A bridge over a peaceful garden pond",
  "A deer standing in a sunlit meadow",
  "Northern lights rippling over icy mountains",
  "A peacock spreading a shimmering fan",
  "A winding trail through a bamboo grove",
  "A hot-air balloon floating above the countryside",
  "A swan gliding through silver water",
  "A cactus blooming under a desert sun",
  "A tree of life with colorful branching leaves",
  "A family of whales beneath rolling waves",
  "A cozy cottage surrounded by lavender",
  "A falling star crossing a violet sky",
  "A lotus flower opening on still water",
  "A flock of cranes flying over wetlands",
  "A humming forest after a gentle rain",
  "A seashell holding the colors of the ocean",
  "A harvest moon rising over golden fields",
  "A koi fish swimming through a garden pond",
  "A wild horse running across the prairie",
  "A snowflake with delicate crystal branches",
  "A tropical island framed by palm trees",
  "A red panda resting in a leafy canopy",
  "A rolling wave with a crest of seafoam",
  "A bouquet gathered from a spring meadow",
  "A robin singing on a flowering branch",
  "A quiet harbor filled with colorful boats",
  "A spiral galaxy with a luminous center",
  "A hedgehog exploring a mushroom garden",
  "A rose opening in the morning light",
  "A mountain reflected in a crystal-clear lake",
  "A colorful kite dancing above the beach",
  "A kingfisher diving into a blue river",
  "A stone arch covered in climbing vines",
  "A glowing jellyfish drifting through deep water",
  "A field of wheat beneath drifting clouds",
  "A curious cat sitting in a sunny window",
  "A canyon filled with layers of warm earth colors",
  "A gentle elephant beneath an acacia tree",
  "A flock of flamingos beside a rosy lagoon",
  "A lantern shining in a snowy forest",
  "A grapevine heavy with purple fruit",
  "A playful otter floating down a stream",
  "A sparkling city skyline at twilight",
  "A sunflower field beneath a brilliant blue sky",
  "A graceful manta ray above an ocean garden",
  "A rainbow-colored dragon curled around a castle",
  "A train winding through emerald mountains",
  "A dandelion scattering seeds into the wind",
  "A pair of lovebirds on a flowering branch",
  "A secret garden behind an old wooden gate",
  "A crescent of sand around a hidden lagoon",
  "A firefly festival in a summer meadow",
  "A sleeping bear beside a woodland stream",
  "A windmill overlooking fields of tulips",
  "A comet trailing light across the night sky",
  "A coral reef alive with colorful fish",
  "A friendly dragon breathing ribbons of light",
  "A lemon tree in a sunny courtyard",
  "A mountain village wrapped in morning mist",
  "A pair of dolphins leaping through the waves",
  "A magnolia blossom framed by deep green leaves",
  "A spiral of leaves carried by an autumn breeze",
  "A snowy owl flying over a winter forest",
  "A fountain sparkling in a Mediterranean garden",
  "A little boat beneath a sky of paper lanterns",
  "A reef of seashells arranged like a mandala",
  "A crescent moon cradling a cluster of stars",
  "A garden gate surrounded by climbing roses",
  "A family of penguins beneath a pastel sky",
  "A sunlit orchard full of ripe peaches",
  "A mysterious doorway opening into a starry sky",
  "A mountain stream tumbling over smooth stones",
  "A peaceful planet surrounded by colorful rings",
  "A dance of ribbons, petals, and warm sunlight",
  "A woodland clearing filled with bluebells",
  "An abstract harmony of light, color, and flowing shapes",
] as const;

export function validGlassGoal(value: unknown): value is string {
  return typeof value === "string" && (GLASS_THEMES as readonly string[]).includes(value);
}

/** Every theme can be drawn, and a new suggestion never repeats the current one. */
export function randomGlassGoal(current: string | null, random = Math.random()): string {
  const choices = GLASS_THEMES.filter(theme => theme !== current);
  const fraction = Number.isFinite(random) ? Math.max(0, Math.min(random, 1)) : 0;
  return choices[Math.min(choices.length - 1, Math.floor(fraction * choices.length))];
}
